<template>
    <div class="page-wrapper px-4">
        <TrfGlobalLoader v-if="isLoading" v-e2e="'form-loader'" type="fixed" />

        <div v-else-if="keyValida" class="container">
            <TrfHeader :pageTitle="'Processo de legalização: '+titulo"></TrfHeader>
            <p class="has-text-centered has-text-weight-bold is-size-5">
                Acompanhe o andamento das etapas do seu processo de legalização:
            </p>
            <GChart
                class="is-flex is-justify-content-center"
                ref="progressoChart"
                :type="progressoChart.chartType"
                :data="progressoChart.dados"
                :options="progressoChart.chartOptions"
                :events="progressoChart.chartEvents"
            />

            <SimpleTimeline
                titulo="Etapas do processo"
                :dados="dados"
            ></SimpleTimeline>
        </div>

        <TrfPaginaErro
            v-else
            :tituloDeErro="tituloErroNaoEncontrado"
            :mensagemDeErro="mensagemErroNaoEncontrado"
        />
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { GChart } from 'vue-google-charts'
import { ProgressoToTimelineTransformer, TimelineToChartTransformer } from './transformer/Progresso.transformer.js';

export default {
    name: "Progresso",
    components: {
        TrfHeader: defineAsyncComponent(() => import('../../../components/Header/index.vue')),
        SimpleTimeline: defineAsyncComponent(() => import('../../../components/SimpleTimeline/index.vue')),
        TrfPaginaErro: defineAsyncComponent(() => import('../../../components/PaginaErro/index.vue')),
        TrfGlobalLoader: defineAsyncComponent(() => import('../../../components/GlobalLoader/index.vue')),
        GChart
    },
    data() {
        return {
            isLoading: true,
            keyValida: false,
            titulo: '',
            dados: [],
            progressoChart: {
                dados: [
                    ['Etapas', 'Quantidade'],
                    ['Concluídas', 0],
                    ['Em andamento', 0],
                    ['Pendentes', 0],
                ],
                chartType: 'PieChart',
                chartOptions: {
                    width: 600,
                    height: 250,
                    pieHole: 0.7,
                    pieSliceText : 'none',
                    slices: {
                        0: { color: '#32AA45' },
                        1: { color: '#c8b71b' },
                        2: { color: '#d9d9d9' }
                    }
                },
                chartEvents: {
                    ready: this.carregarTituloChart
                }
            }
        }
    },
    computed: {
        percentualConcluidos() {
            if(!this.dados.length) return 0;
            const concluidos = this.progressoChart.dados[1][1];
            return (concluidos / this.dados.length) * 100;
        },
        tituloErroNaoEncontrado() {
            return '<h1 class="is-size-3">Não foi possível acessar o processo!</h1>'
        },
        mensagemErroNaoEncontrado() {
            return '<p>Parece que o processo de legalização referente ao seu negócio não existe mais.</p><p>Entre em contato com os responsáveis pelo envio.</p>'
        }
    },
    methods: {
        async importProcessoService() {
            const { processoService } = await import('../../../service/processo-service.js')
            return processoService;
        },
        async carregarDados(key) {
            try {
                const service = await this.importProcessoService();
                const response = await service.buscarProgresso({ key });

                this.titulo = response.nomeNegocio;
                this.dados = new ProgressoToTimelineTransformer().transform(response);
                this.progressoChart.dados = new TimelineToChartTransformer().transform(this.dados);
                
                this.keyValida = true;
            } finally {
                this.isLoading = false;
            } 
        },
        carregarTituloChart() {
            const svg = this.$refs.progressoChart.$el.querySelector('svg');
            const url = "http://www.w3.org/2000/svg";

            const textElement = document.createElementNS(url, "text");
            textElement.setAttribute("x", 220);
            textElement.setAttribute("y", 120);
            textElement.setAttribute("text-anchor", "middle");
            textElement.setAttribute("dominant-baseline", "central");
            textElement.setAttribute("font-size", "20");
            textElement.setAttribute("fill", "black");
            textElement.style.fontSize = "x-large";
            textElement.style.fontWeight = "bold";

            textElement.textContent = this.percentualConcluidos.toFixed(0) + '%';
            svg.appendChild(textElement);

            const textLabelElement = document.createElementNS(url, "text");
            textLabelElement.setAttribute("x", 220);
            textLabelElement.setAttribute("y", 135);
            textLabelElement.setAttribute("text-anchor", "middle");
            textLabelElement.setAttribute("dominant-baseline", "hanging");
            textLabelElement.setAttribute("font-size", "14");
            textLabelElement.setAttribute("fill", "black");
            textLabelElement.style.fontSize = "smaller"
            textLabelElement.textContent = 'Concluído';
            svg.appendChild(textLabelElement);
        }
    },
    async beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            await vm.carregarDados(to.query.key);
        });
    },
}
</script>